export default "__VITE_ASSET__e8Opg_ub__"